import React from 'react';
import { Button } from './ui/button';
import { Trash2, CheckCircle2, XCircle } from 'lucide-react';

/**
 * Reusable Pending Deletions Panel.
 * Props:
 *   module (string), requests (array), onApprove (fn(reqId)), onReject(fn(reqId))
 */
const PendingDeletionsPanel = ({ module, requests, onApprove, onReject }) => {
  if (!requests || requests.length === 0) return null;

  const moduleRequests = requests.filter(r => !module || r.module === module);
  if (moduleRequests.length === 0) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 space-y-2" data-testid="pending-deletions-panel">
      <div className="flex items-center gap-2 mb-1">
        <Trash2 className="h-4 w-4 text-red-600" />
        <h3 className="font-semibold text-red-800 text-sm">
          Pending Deletion Requests ({moduleRequests.length})
        </h3>
      </div>
      {moduleRequests.map(req => (
        <div key={req.id} className="flex items-start justify-between bg-white rounded border border-red-100 px-3 py-2 gap-4">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-slate-800 truncate">{req.record_display}</p>
            <p className="text-xs text-slate-500">
              By <span className="font-medium">{req.requested_by_name}</span>
              {req.created_at && ` · ${new Date(req.created_at).toLocaleDateString('en-IN')}`}
            </p>
            {req.reason && (
              <p className="text-xs text-slate-600 italic mt-0.5">
                Reason: {req.reason}
              </p>
            )}
          </div>
          <div className="flex gap-1.5 flex-shrink-0">
            <Button
              size="sm"
              variant="outline"
              className="h-7 text-xs text-green-700 border-green-300 hover:bg-green-50 gap-1"
              onClick={() => onApprove(req.id)}
              data-testid={`approve-delete-${req.id}`}
            >
              <CheckCircle2 className="h-3 w-3" /> Approve
            </Button>
            <Button
              size="sm"
              variant="outline"
              className="h-7 text-xs text-red-700 border-red-300 hover:bg-red-50 gap-1"
              onClick={() => onReject(req.id)}
              data-testid={`reject-delete-${req.id}`}
            >
              <XCircle className="h-3 w-3" /> Reject
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PendingDeletionsPanel;
